import PropTypes from 'prop-types';

import { useTheme } from '@mui/material/styles';

import SortableTableComponent from '../Table/SortableTableComponent';

import { formatDate } from '../../utils';
import { getExportTitle } from '../ViewExport/utils';

import { TABLE_CONSTANTS, TABLE_ID } from '../Table/constants';

import { TABLE_DATA_TYPES } from '../../staticData';
import ListActions from '../Table/ListActions';
import IPManagementExport from './IPManagementExport';

const IPManagementComponent = ({ ipsList, onLoad, onDelete }) => {
  const theme = useTheme();
  const columns = [
    {
      Header: 'ID',
      accessor: 'id',
      width: 120,
      id: 'id',
      headerClassName: 'sort',
      dataKey: 'id',
    },
    {
      Header: 'Start IP',
      accessor: 'startIp',
      id: 'startIp',
      headerClassName: 'sort',
      dataKey: 'startIp',
      filter: true,
    },
    {
      Header: 'End IP',
      accessor: 'endIp',
      id: 'endIp',
      headerClassName: 'sort',
      dataKey: 'endIp',
      filter: true,
    },
    {
      Header: 'Name',
      accessor: 'name',
      id: 'name',
      headerClassName: 'sort',
      dataKey: 'name',
      filter: true,
    },
    {
      Header: 'Updated At',
      id: 'updatedAt',
      accessor: ({ updatedAt }) => formatDate(updatedAt),
      headerClassName: 'sort',
      dataKey: 'updatedAt',
      filter: true,
    },
    {
      Header: 'Actions',
      id: 'actions',
      fixed: 'right',
      sortable: false,
      width: 120,
      accessor: (entry) => {
        const actions = [
          {
            label: 'Remove',
            color: theme.palette.secondary.main,
            onClick: () => onDelete(entry),
            isFullWidth: true,
          },
        ];

        return <ListActions actions={actions} isFullWidth />;
      },
    },
  ];

  const tableDataType = TABLE_DATA_TYPES.ip;
  const action = [
    {
      url: '/ip-management/create',
      label: 'Add IP',
    },
  ];

  const title = 'IP Management';
  const exportTitle = getExportTitle(title, null, null);
  const getExportActions = (entries) => {
    const onExport = () => ({ data: { results: Object.values(entries) } });
    const exportActions = (
      <IPManagementExport
        title={exportTitle}
        getDataForExport={onExport}
        columns={columns}
      />
    );
    return exportActions;
  };

  return (
    <SortableTableComponent
      tableId={TABLE_ID.ipManagementTable}
      title={title}
      onLoad={onLoad}
      columns={columns}
      defaultSort={TABLE_CONSTANTS.name}
      entries={Object.values(ipsList)}
      pluralModelName={title}
      action={<ListActions actions={action} />}
      tableDataType={tableDataType}
      getExportActions={getExportActions}
    />
  );
};

IPManagementComponent.propTypes = {
  ipsList: PropTypes.instanceOf(Object).isRequired,
  onLoad: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default IPManagementComponent;
